import classNames from "classnames";

import IconMinus from "@/icons/icon-minus";
import IconPlus from "@/icons/icon-plus";

import Icon from "./icon";
import styles from "./quantity-selector.module.scss";

type Props = {
  onClick: (removing: boolean) => void;
  quantity: number;
  classNames?: string;
  disableRemove?: boolean;
  disableAdd?: boolean;
};

export default function SimpleQuantitySelector(props: Props) {
  return (
    <div className={classNames(styles.quantitySelector, props.classNames)}>
      <button
        type="button"
        className={styles.simpleQtyBtn}
        disabled={props.disableRemove}
        onClick={() => !props.disableRemove && props.onClick(true)}
      >
        <Icon icon={IconMinus} width={16} height={16} />
      </button>
      <p className={styles.textQty}>{props.quantity}</p>
      <button
        type="button"
        className={styles.simpleQtyBtn}
        disabled={props.disableAdd}
        onClick={() => !props.disableAdd && props.onClick(false)}
      >
        <Icon icon={IconPlus} width={16} height={16} />
      </button>
    </div>
  );
}
